import { Dayjs } from 'dayjs';
import { useTranslation } from 'react-i18next';

import type { CalendarEvent } from 'src/Components/Calendars/MonthCalendar/MonthCalendar.types';

import styles from '../ListCalendar.module.scss';

interface Props {
  date: Dayjs;
  markers: CalendarEvent[];
  isToday: boolean;
  onDateClick?: (date: Date) => void;
}

const DayRow = ({ date, markers, isToday, onDateClick }: Props) => {
  const { i18n } = useTranslation();
  const localized = date.locale(i18n.language);

  return (
    <button
      className={styles.dayRow}
      onClick={() => onDateClick?.(date.toDate())}
      type="button"
      aria-current={isToday ? 'date' : undefined}
    >
      <span className={`${styles.dayNumber} ${isToday ? styles.dayNumberToday : ''}`}>
        {localized.format('D')}
      </span>
      <span className={styles.dayMeta}>
        <span className={styles.dayWeekday}>{localized.format('ddd')}</span>
        {markers.length > 0 && (
          <span className={styles.dayMarkers}>
            {markers.map(marker => marker.name).join(' · ')}
          </span>
        )}
      </span>
    </button>
  );
};

export default DayRow;
